import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { GenericMdrShell } from '@ubc/mdr-shell-react';
import '../../../design-systems/ops-neutral/tokens.css';
import '../../../design-systems/arcade/tokens.css';
import '../../../design-systems/bakery/tokens.css';

const root = document.getElementById('root');
if (!root) throw new Error('Public shell root is missing');

createRoot(root).render(
  <StrictMode>
    <GenericMdrShell apiBaseUrl={import.meta.env.VITE_API_BASE_URL} surface="public" />
  </StrictMode>,
);
